import { createSelector } from 'reselect'

export const FirebaseAuth = (s: any) => s.firebase.auth

export const selectUID = createSelector(
  FirebaseAuth,
  (auth): string => auth?.uid
)
